module.exports = __webpack_public_path__ + "img/no-tasks.3bd33075.svg";